export default "/images/6e203fcf5b7d5e1b6c62254eaecaac0b.png";